var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:#fff;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -272,
    y1: 110.84,
    x2: -272,
    y2: 80.84,
    gradientTransform: "matrix(1, 0, 0, -1, 287, 110.84)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#61fd7d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2bb826"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30,22.39c0,.16,0,.52,0,.79a15.69,15.69,0,0,1-.15,1.94,6.81,6.81,0,0,1-.55,1.63,5.83,5.83,0,0,1-2.54,2.54,6.71,6.71,0,0,1-1.64.54,16.75,16.75,0,0,1-1.92.16H7.61c-.16,0-.52,0-.79,0a15.69,15.69,0,0,1-1.94-.15,6.2,6.2,0,0,1-1.62-.55A5.8,5.8,0,0,1,.71,26.74,6.71,6.71,0,0,1,.17,25.1,17.54,17.54,0,0,1,0,23.18c0-.28,0-.63,0-.8V7.61c0-.16,0-.52,0-.79A15,15,0,0,1,.18,4.88,6.18,6.18,0,0,1,.72,3.26,5.8,5.8,0,0,1,3.26.71,6.71,6.71,0,0,1,4.9.17,17.54,17.54,0,0,1,6.82,0H23.18a17,17,0,0,1,1.94.16,6.4,6.4,0,0,1,1.63.55,5.78,5.78,0,0,1,2.54,2.54,6.78,6.78,0,0,1,.54,1.63A17.16,17.16,0,0,1,30,6.82c0,.27,0,.63,0,.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M23,7.1A10.76,10.76,0,0,0,6,20.07L4.49,25.65l5.7-1.5a10.64,10.64,0,0,0,5.14,1.3h0A10.75,10.75,0,0,0,23,7.1ZM15.34,23.64a9,9,0,0,1-4.55-1.24l-.34-.2-3.38.89L8,19.8l-.22-.34a8.93,8.93,0,1,1,7.58,4.19ZM20.24,17c-.27-.14-1.59-.79-1.83-.88s-.43-.13-.61.14-.69.87-.85,1.05-.31.21-.58.07A7.49,7.49,0,0,1,14.21,16a8.17,8.17,0,0,1-1.5-1.86c-.16-.27,0-.41.12-.55s.27-.31.41-.47a1.86,1.86,0,0,0,.27-.45.45.45,0,0,0,0-.23.4.4,0,0,0-.07-.24c-.06-.13-.6-1.45-.83-2s-.44-.46-.6-.47h-.51a1.11,1.11,0,0,0-.4.09,1,1,0,0,0-.32.25,3,3,0,0,0-.94,2.24A5.19,5.19,0,0,0,11,15.09a11.94,11.94,0,0,0,4.59,4.06c.5.21,1,.4,1.52.56a3.62,3.62,0,0,0,1.7.11,2.77,2.77,0,0,0,1.81-1.28,2.38,2.38,0,0,0,.16-1.28C20.69,17.15,20.51,17.08,20.24,17Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.7f86df7439b2274cf971b533dafc091c.svg";
export { ForwardRef as ReactComponent };